import React from "react";
import { StyledClient } from "../components/Styles";
import Consultation from "../components/Consultation";
import ClientHorizontalCard from "../components/ClientHorizontalCard";

import i4 from "../components/Styles/assets/Graphics/Restaurant1.webp";
import Restaurant2 from "../components/Styles/assets/Graphics/Restaurant2.webp";
import Restaurant10 from "../components/Styles/assets/Graphics/Restaurant10.webp";
import Restaurant7 from "../components/Styles/assets/Graphics/Restaurant7.webp";
import Restaurant8 from "../components/Styles/assets/Graphics/Restaurant8.webp";
import Restaurant11 from "../components/Styles/assets/Graphics/Restaurant11.webp";

import { useTranslation } from "react-i18next";

const cardKeys = [
  "fillTables",
  "boostSEO",
  "stunningWebsite",
  "onlineOrders",
  "socialMediaMarketing"
];

const icons = {
  fillTables: Restaurant2,
  boostSEO: Restaurant7,
  stunningWebsite: Restaurant8,
  onlineOrders: Restaurant10,
  socialMediaMarketing: Restaurant11
};

const RestaurantCafe = () => {
  const { t, i18n } = useTranslation();

  return (
    <StyledClient.Container>
      <StyledClient.Content>
        <StyledClient.ShapeTopLeft>
          <img src={i4} alt="Icon" />
        </StyledClient.ShapeTopLeft>

        <StyledClient.Title>
          <span>{t("restaurant.titleSpan")}</span>
          {t("restaurant.title")}
        </StyledClient.Title>

        <StyledClient.Description>
          {t("restaurant.description")}
        </StyledClient.Description>
      </StyledClient.Content>

      <Consultation />

      <StyledClient.H3 lang={i18n.language}>{t("restaurant.servicesTitle")}</StyledClient.H3>

      {cardKeys.map((key, index) => (
        <ClientHorizontalCard
          key={index}
          title={t(`restaurant.cards.${key}.title`)}
          subtitle={t(`restaurant.cards.${key}.subtitle`)}
          visionPoints={t(`restaurant.cards.${key}.vision`, { returnObjects: true })}
          missionPoints={t(`restaurant.cards.${key}.mission`, { returnObjects: true })}
          icon={icons[key]}
        />
      ))}

      <Consultation />
    </StyledClient.Container>
  );
};

export default RestaurantCafe;